const ZigZagSeparator = () => {
    return (
        <svg
            viewBox="0 0 300 10"
            preserveAspectRatio="none"
            className="w-full h-4"
        >
            <polyline
                points="
                    0,0 5,10 10,0 15,10 20,0 25,10 30,0 35,10 40,0 45,10 50,0
                    55,10 60,0 65,10 70,0 75,10 80,0 85,10 90,0 95,10 100,0
                    105,10 110,0 115,10 120,0 125,10 130,0 135,10 140,0 145,10 150,0
                    155,10 160,0 165,10 170,0 175,10 180,0 185,10 190,0 195,10 200,0
                    205,10 210,0 215,10 220,0 225,10 230,0 235,10 240,0 245,10 250,0
                    255,10 260,0 265,10 270,0 275,10 280,0 285,10 290,0 295,10 300,0
                "
                stroke="#facc15"
                strokeWidth=".4"
                fill="none"
            />
        </svg>
    );
};

export default ZigZagSeparator;
